import { Component } from '@angular/core';
import { Paginator } from '@app/classes/paginator';
import { PayrollModuleMenuService } from '@app/modules/payroll/services/payroll-module-menu.service';
import { AuthService } from '@app/services/auth.service';
import { IndexView } from '@common/views/index/index.view';
import { Payroll } from '@models/payroll/payroll.model';
import { PayrollStates } from '@payroll/enums/payroll-state.enum';

@Component({
    templateUrl: './payroll-index.template.html',
    styleUrls: ['./payroll-index.style.scss'],
})
export class PayrollIndexView extends IndexView {
    isLoading = true;
    paginator: Paginator;

    constructor(
        private auth: AuthService,
        public payrollModuleMenuService: PayrollModuleMenuService
    ) {
        super();

        this.paginator = new Paginator(
            Payroll.param('company', this.auth.company.id).where('states', [PayrollStates.Locked, PayrollStates.Paid]),
            { shouldAutoLoadData: true }
        );
        this.paginator.onLoading((isLoading) => (this.isLoading = isLoading));
    }

    onCreate(): void {}
}
